export default __webpack_public_path__ + "static/7-786d31610a3d27763dd30b7dcba8838d.png";